/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChargerMeterValue
 */
export interface ChargerMeterValue {
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    chargerMeterValueId?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    transactionId?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    stateOfCharge?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    currentOfferedA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    powerOfferedW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    gridActivePowerExportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    gridActivePowerImportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    solarActivePowerImportW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    gridActiveEnergyExportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    gridActiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    solarEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    totalCost?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    pricingScheduleId?: number;
    /**
     *
     * @type {Date}
     * @memberof ChargerMeterValue
     */
    timestamp?: Date;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    frequencyHz?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l1VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l2VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l3VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l1CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l2CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l3CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l1ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l2ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l3ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l1ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l2ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    l3ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    totalActiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    totalReactiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    totalActiveEnergyExportWh?: number;
    /**
     *
     * @type {number}
     * @memberof ChargerMeterValue
     */
    totalReactiveEnergyExportWh?: number;
}

/**
 * Check if a given object implements the ChargerMeterValue interface.
 */
export function instanceOfChargerMeterValue(
    value: object,
): value is ChargerMeterValue {
    return true;
}

export function ChargerMeterValueFromJSON(json: any): ChargerMeterValue {
    return ChargerMeterValueFromJSONTyped(json, false);
}

export function ChargerMeterValueFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargerMeterValue {
    if (json == null) {
        return json;
    }
    return {
        chargerMeterValueId:
            json["chargerMeterValueId"] == null
                ? undefined
                : json["chargerMeterValueId"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        stateOfCharge:
            json["stateOfCharge"] == null ? undefined : json["stateOfCharge"],
        currentOfferedA:
            json["currentOfferedA"] == null
                ? undefined
                : json["currentOfferedA"],
        powerOfferedW:
            json["powerOfferedW"] == null ? undefined : json["powerOfferedW"],
        gridActivePowerExportW:
            json["gridActivePowerExportW"] == null
                ? undefined
                : json["gridActivePowerExportW"],
        gridActivePowerImportW:
            json["gridActivePowerImportW"] == null
                ? undefined
                : json["gridActivePowerImportW"],
        solarActivePowerImportW:
            json["solarActivePowerImportW"] == null
                ? undefined
                : json["solarActivePowerImportW"],
        gridActiveEnergyExportWh:
            json["gridActiveEnergyExportWh"] == null
                ? undefined
                : json["gridActiveEnergyExportWh"],
        gridActiveEnergyImportWh:
            json["gridActiveEnergyImportWh"] == null
                ? undefined
                : json["gridActiveEnergyImportWh"],
        solarEnergyImportWh:
            json["solarEnergyImportWh"] == null
                ? undefined
                : json["solarEnergyImportWh"],
        totalCost: json["totalCost"] == null ? undefined : json["totalCost"],
        pricingScheduleId:
            json["pricingScheduleId"] == null
                ? undefined
                : json["pricingScheduleId"],
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        frequencyHz:
            json["frequencyHz"] == null ? undefined : json["frequencyHz"],
        l1VoltageRmsV:
            json["l1VoltageRmsV"] == null ? undefined : json["l1VoltageRmsV"],
        l2VoltageRmsV:
            json["l2VoltageRmsV"] == null ? undefined : json["l2VoltageRmsV"],
        l3VoltageRmsV:
            json["l3VoltageRmsV"] == null ? undefined : json["l3VoltageRmsV"],
        l1CurrentRmsA:
            json["l1CurrentRmsA"] == null ? undefined : json["l1CurrentRmsA"],
        l2CurrentRmsA:
            json["l2CurrentRmsA"] == null ? undefined : json["l2CurrentRmsA"],
        l3CurrentRmsA:
            json["l3CurrentRmsA"] == null ? undefined : json["l3CurrentRmsA"],
        l1ActivePowerRmsW:
            json["l1ActivePowerRmsW"] == null
                ? undefined
                : json["l1ActivePowerRmsW"],
        l2ActivePowerRmsW:
            json["l2ActivePowerRmsW"] == null
                ? undefined
                : json["l2ActivePowerRmsW"],
        l3ActivePowerRmsW:
            json["l3ActivePowerRmsW"] == null
                ? undefined
                : json["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar:
            json["l1ReactivePowerRmsVar"] == null
                ? undefined
                : json["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar:
            json["l2ReactivePowerRmsVar"] == null
                ? undefined
                : json["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar:
            json["l3ReactivePowerRmsVar"] == null
                ? undefined
                : json["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh:
            json["totalActiveEnergyImportWh"] == null
                ? undefined
                : json["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh:
            json["totalReactiveEnergyImportWh"] == null
                ? undefined
                : json["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh:
            json["totalActiveEnergyExportWh"] == null
                ? undefined
                : json["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh:
            json["totalReactiveEnergyExportWh"] == null
                ? undefined
                : json["totalReactiveEnergyExportWh"],
    };
}

export function ChargerMeterValueToJSON(value?: ChargerMeterValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        chargerMeterValueId: value["chargerMeterValueId"],
        transactionId: value["transactionId"],
        stateOfCharge: value["stateOfCharge"],
        currentOfferedA: value["currentOfferedA"],
        powerOfferedW: value["powerOfferedW"],
        gridActivePowerExportW: value["gridActivePowerExportW"],
        gridActivePowerImportW: value["gridActivePowerImportW"],
        solarActivePowerImportW: value["solarActivePowerImportW"],
        gridActiveEnergyExportWh: value["gridActiveEnergyExportWh"],
        gridActiveEnergyImportWh: value["gridActiveEnergyImportWh"],
        solarEnergyImportWh: value["solarEnergyImportWh"],
        totalCost: value["totalCost"],
        pricingScheduleId: value["pricingScheduleId"],
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        frequencyHz: value["frequencyHz"],
        l1VoltageRmsV: value["l1VoltageRmsV"],
        l2VoltageRmsV: value["l2VoltageRmsV"],
        l3VoltageRmsV: value["l3VoltageRmsV"],
        l1CurrentRmsA: value["l1CurrentRmsA"],
        l2CurrentRmsA: value["l2CurrentRmsA"],
        l3CurrentRmsA: value["l3CurrentRmsA"],
        l1ActivePowerRmsW: value["l1ActivePowerRmsW"],
        l2ActivePowerRmsW: value["l2ActivePowerRmsW"],
        l3ActivePowerRmsW: value["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar: value["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar: value["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar: value["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh: value["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh: value["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh: value["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh: value["totalReactiveEnergyExportWh"],
    };
}
